<template>
  <div class="tableDiv">
    <table class="sample-table">
      <thead class="sample-table-thead">
      <tr>
        <th>序号</th>
        <th>分组名</th>
        <th>样本数量</th>
        <th>样本名</th>
      </tr>
      </thead>
      <tbody class="sample-table-tbody">
      <template v-if="groupList.length">
        <tr v-for="(item,key) in groupList" :key="key">
          <td class="td-item td-index">{{ key+1 }}</td>
          <td class="td-item td-group">{{ item.groupName }}</td>
          <td class="td-item td-num" >{{ item.sampleList.length }}</td>
          <td class="samples">
            <div v-for="(sampleName,index) in item.sampleList" :key="index">
              <w-ellipsis-and-look class="w-ellipsis-and-look"
                                   :showLength="12"
                                   :text="sampleName"
                                   :column="{title:'样本名'}" >
              </w-ellipsis-and-look>
            </div>
          </td>
        </tr>
      </template>
      <tr v-else>
        <td colspan="3" style="text-align: center;padding: 20px">
          <img src="images/empty.png" style="height: 130px;">
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'groupSample',
  props: {
    groupList: {}

  }
}
</script>
<style scoped>
.tableDiv{
  max-height: calc(100vh - 330px);
  overflow-y: auto;
  position: relative;
}
.sample-table-thead th{
  position: sticky;
  top: 0;
  z-index: 1;
}
.sample-table {
  text-align: center;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  background-color: #ffffff;
}

.sample-table th {
  font-size: 14px;
  color: rgba(103, 103, 103, 0.87);
  padding: 12px 15px;
  background-color: #ffffff;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.sample-table th:first-child {
  border-left: 1px solid #ebeef5;
}

.td-item {
  padding: 12px 15px;
}
.sample-table-tbody{
  color: #707070;
}
.sample-table td {
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.sample-table td:first-child {
  border-left: 1px solid #ebeef5;
}

.sample-table tr:hover td {
  background-color: #f9fafc;
}

.samples {
  line-height: 24px;
  padding-left: 0;
  margin: 0;
}

.samples div {
  padding: 2px 15px;
  font-size: 14px;
}

.samples div:not(:last-child) {
  border-bottom: 1px #e8e8e8 solid;
}
.td-index{
  width: 80px;
}

.td-num{
  width: 100px;
  text-align: center;
}
</style>
